module.exports = __webpack_public_path__ + "static/media/Fusion360.a5940c7e.png";